import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { BesichtigungsStatiQuerySorterConfig } from 'fa-kt.types';
import { BesichtigungsStatiService } from '../service';

@Component({
  selector: 'fa-kt-besichtigungs-stati-sorter',
  templateUrl: './besichtigungs-stati-sorter.component.html',
  styleUrls: ['./besichtigungs-stati-sorter.component.css'],
})
export class BesichtigungsStatiSorterComponent {
  BesichtigungsStatiSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public besichtigungsStati: BesichtigungsStatiService,
  ) {
    this.BesichtigungsStatiSorterConfig = BesichtigungsStatiQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
  }
}
